'use client'

import { Button } from '../ui/button'
import { Send } from 'lucide-react'
import { useTranslations } from 'next-intl'

export interface Props {
  id: string
}

export default function ConferenceBooking({ id }: Props) {
  const t = useTranslations()

  return (
    <Button asChild className='h-12 w-full rounded-full' variant='secondary'>
      <a href={`https://inbox.proposales.com/${id}`}>
        {t('send_us_a_request')} <Send />
      </a>
    </Button>
  )
}
